import { memo, useMemo } from 'react';

import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import styles from './GameItem.module.scss';

const GameItem = ({ order, gameName, icon, backgroundColor }) => {
  const color = useMemo(
    () => (backgroundColor ? 'white' : 'dark'),
    [backgroundColor],
  );

  return (
    <div className={styles.root} style={{ backgroundColor }}>
      <Typography color={color}>#{order}</Typography>
      <div className={styles.nameWrapper}>
        <img src={icon} alt="game_icon" className={styles.icon} />
        <Typography color={color}>{gameName}</Typography>
      </div>
    </div>
  );
};

GameItem.propTypes = {
  order: PropTypes.number.isRequired,
  gameName: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
};

export default memo(GameItem);
